var React = require('react');

function ButtonShape06 (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"st1","d":"M24.21,2.7C7.56,3.54-1.32,11.99,0.16,38.72c1.56,28.13,5.85,33.05,41.81,35.71\n\tc24.04,1.78,83.72,3.42,106.26,0.89c22.39-2.51,28.08-12.45,29.48-32.22c1.32-18.76-4.02-28.08-31.02-34.54\n\tC111.79,0.21,56.09,1.07,24.21,2.7z"}));
}

ButtonShape06.defaultProps = {"viewBox":"0 0 177.89 78.25"};

module.exports = ButtonShape06;

ButtonShape06.default = ButtonShape06;
